import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

import { EmptyState } from "@/ds";
import { AnexoDialog } from "@/shared/components";
import { FichaAnexoRemocao } from "../ficha-anexo-remocao";
import {
  ANEXO_REMOVER_LABEL,
  ANEXOS_ADICIONAR,
  ANEXOS_DICA_ANTES,
  ANEXOS_DICA_DEPOIS,
  ANEXOS_VAZIO_TITULO,
  FICHA_ANEXO_DIALOG_PROPS,
} from "../ficha-anexos/ficha-anexos.constants";
import styles from "../ficha-anexos/ficha-anexos.module.scss";
import type { FichaAnexosPreviaViewModel } from "./types-ficha-anexos-previa";

/** Título, Adicionar Arquivo e a relação dos anexos ainda em memória (identificação, formato, tamanho e lixeira). */
export function FichaAnexosPreviaView({
  title,
  isMobile,
  linhas,
  bloqueado,
  incluindo,
  abrirInclusao,
  cancelarInclusao,
  salvarInclusao,
  removendoIdentificacao,
  pedirRemocao,
  cancelarRemocao,
  confirmarRemocao,
}: FichaAnexosPreviaViewModel) {
  return (
    <section
      className={styles.secao}
      data-section-id="anexos"
      aria-labelledby="ficha-anexos-titulo"
      data-testid="ficha-section-anexos"
    >
      <div className={styles.cabecalho}>
        <h3 className={styles.titulo} id="ficha-anexos-titulo">
          {title}
        </h3>
        <Button
          type="button"
          label={ANEXOS_ADICIONAR}
          icon="pi pi-upload"
          severity="secondary"
          disabled={bloqueado}
          onClick={abrirInclusao}
          data-testid="ficha-anexos-add"
        />
      </div>

      {linhas.length === 0 ? (
        <EmptyState.Root size="sm" testId="ficha-anexos-empty" className={styles.vazio}>
          <EmptyState.Illustration name="sem-equipe" />
          <EmptyState.Title>{ANEXOS_VAZIO_TITULO}</EmptyState.Title>
          <EmptyState.Description>
            {ANEXOS_DICA_ANTES}
            <strong>{ANEXOS_ADICIONAR}</strong>
            {ANEXOS_DICA_DEPOIS}
          </EmptyState.Description>
        </EmptyState.Root>
      ) : (
        <ul className={styles.lista} data-testid="ficha-anexos-lista">
          {linhas.map((linha) => (
            <li key={linha.id} className={styles.item} data-testid={linha.testIds.linha}>
              <span className={styles.identificacao}>{linha.identificacao}</span>
              <Tag value={linha.formato} severity="secondary" />
              <span className={styles.tamanho}>{linha.tamanho}</span>
              <span className={styles.acoes}>
                <Button
                  type="button"
                  icon="pi pi-trash"
                  text
                  severity="secondary"
                  disabled={bloqueado}
                  aria-label={`${ANEXO_REMOVER_LABEL}: ${linha.identificacao}`}
                  onClick={() => pedirRemocao(linha.id)}
                  data-testid={linha.testIds.remover}
                />
              </span>
            </li>
          ))}
        </ul>
      )}

      {incluindo ? (
        <AnexoDialog
          {...FICHA_ANEXO_DIALOG_PROPS}
          isMobile={isMobile}
          onSalvar={salvarInclusao}
          onCancelar={cancelarInclusao}
        />
      ) : null}

      {removendoIdentificacao !== null ? (
        <FichaAnexoRemocao
          identificacao={removendoIdentificacao}
          onConfirmar={confirmarRemocao}
          onCancelar={cancelarRemocao}
        />
      ) : null}
    </section>
  );
}
